import { useEffect, useState } from 'react';
import { Stack, Typography, Box } from '@mui/material';
import { getReadings } from '../../services/sensorTelemetryService';

const POLL_MS = 45_000;
const WINDOW_MS = 3_600_000;

function SensorReadings({ sensor }) {
  const [latest, setLatest] = useState(null);
  useEffect(() => {
    let active = true;
    const fetchLatest = () => {
      const now = Date.now();
      getReadings(sensor.id, now - WINDOW_MS, now)
        .then((rows) => { if (active && rows && rows.length) setLatest(rows[rows.length - 1]); })
        .catch(() => {});
    };
    fetchLatest();
    const h = setInterval(fetchLatest, POLL_MS);
    return () => { active = false; clearInterval(h); };
  }, [sensor.id]);

  const asOf = latest ? new Date(latest.t).toLocaleTimeString() : null;
  const values = latest
    ? Object.entries(latest).filter(([k]) => k !== 't').map(([k, v]) => `${k}: ${v}`).join('  ')
    : 'no data yet';
  return (
    <Box>
      <Typography variant="subtitle2">{sensor.name}</Typography>
      <Typography variant="body2">{values}</Typography>
      {asOf && <Typography variant="caption" color="text.secondary">as of {asOf}</Typography>}
    </Box>
  );
}

export default function ConnectedReadingsPanel({ sensors }) {
  if (!sensors || sensors.length === 0) {
    return <Typography variant="caption" color="text.secondary">No sensors linked</Typography>;
  }
  return (
    <Stack spacing={2}>
      {sensors.map((s) => <SensorReadings key={s.id} sensor={s} />)}
    </Stack>
  );
}
